import { Type } from "@angular/core";
import { Profile } from "@dynamic-mapper/mapper";
import { UserProfile } from "./user/user.mappings";
import { LocationProfile } from "./location/location.mapping";

export const MAPPING_PROFILES: Type<Profile>[] = [
    UserProfile,
    LocationProfile
]
